export const arrayToMap = (array, key) => {
  const map = {};
  for (const item of array) {
    map[item[key]] = item;
  }
  return map;
};

export const arrayToCategorizedMap = (array, categoryKey) => {
  const map = {};
  for (const item of array) {
    const key = item[categoryKey];
    if (!map[key]) {
      map[key] = [];
    }
    map[key].push(item);
  }
  return map;
};

export const arrayToCategorizedMapWithMultipleKeys = (array, categoryKey) => {
  const map = {};
  for (const item of array) {
    for (const key of item[categoryKey]) {
      if (!map[key]) {
        map[key] = [];
      }
      map[key].push(item);
    }
  }
  return map;
};

export const mapObject = (object, callback) => {
  const map = {};
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      map[key] = callback(object[key]);
    }
  }
  return map;
};


// WEBPACK FOOTER //
// ./lib/masterData/util.js